module.exports = __webpack_public_path__ + "img/activity-4.5cfb0192.jpg";